import { keyframes } from 'tss-react';
import { makeStyles } from 'tss-react/mui';

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, 0.5rem);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
`;

export const useViewerModeBannerStyles = makeStyles()(() => ({
  banner: {
    position: 'absolute',
    left: '50%',
    bottom: '1.25rem',
    transform: 'translateX(-50%)',
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    gap: '0.6rem',
    maxWidth: 'calc(100% - 2rem)',
    padding: '0.35rem 0.4rem 0.35rem 0.9rem',
    borderRadius: '999px',
    background: 'rgba(17, 24, 39, 0.86)',
    color: '#fff',
    backdropFilter: 'blur(6px)',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.28)',
    fontSize: '0.8rem',
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    // The pill itself never blocks the slide; only its button is clickable.
    pointerEvents: 'none',
    animation: `${slideUp} 160ms ease-out`,
  },
  icon: {
    fontSize: '1.05rem',
    opacity: 0.95,
  },
  title: {
    fontWeight: 600,
  },
  detail: {
    opacity: 0.72,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  exitButton: {
    pointerEvents: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '0.4rem',
    marginLeft: '0.25rem',
    padding: '0.25rem 0.6rem 0.25rem 0.35rem',
    borderRadius: '999px',
    background: 'rgba(255, 255, 255, 0.12)',
    color: '#fff',
    fontSize: '0.78rem',
    fontWeight: 600,
    lineHeight: 1.2,
    transition: 'background 120ms ease-out',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.24)',
    },
    '&:focus-visible': {
      outline: '2px solid #90caf9',
      outlineOffset: '1px',
    },
  },
  key: {
    display: 'inline-block',
    padding: '0.1rem 0.4rem',
    borderRadius: '0.3rem',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    borderBottomWidth: '2px',
    background: 'rgba(255, 255, 255, 0.1)',
    fontFamily: 'inherit',
    fontSize: '0.68rem',
    fontWeight: 700,
    letterSpacing: '0.03em',
    lineHeight: 1.3,
  },
  exitIcon: {
    fontSize: '0.95rem',
    opacity: 0.85,
  },
}));
